import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const NewsfeedEditor = () => {
  const columns = [
    { key: 'date', label: 'Date', type: 'date' },
    { key: 'title_en', label: 'Title (EN)', type: 'text' },
    { key: 'title_ms', label: 'Title (MS)', type: 'text' },
    { key: 'subtitle_en', label: 'Subtitle (EN)', type: 'text' },
    { key: 'subtitle_ms', label: 'Subtitle (MS)', type: 'text' },
    { key: 'description1_en', label: 'Content (EN)', type: 'textarea' },
    { key: 'description1_ms', label: 'Content (MS)', type: 'textarea' },
    { key: 'description2_en', label: 'Content 2 (EN)', type: 'textarea' },
    { key: 'description2_ms', label: 'Content 2 (MS)', type: 'textarea' },
    { key: 'cover_image', label: 'Cover Image', type: 'image' },
    { key: 'image', label: 'Secondary Image', type: 'image' },
  ];

  return <GenericTableEditor tableName="newsfeed" columns={columns} title="Newsfeed Manager" />;
};

export default NewsfeedEditor;
